{
	"name": "@cloudillo/notillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Notillo wiki app",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"ts": "tsgo --noEmit",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"test": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"test:coverage": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --coverage",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@blocknote/core": "^0.56.0",
		"@blocknote/mantine": "^0.56.0",
		"@blocknote/react": "^0.56.0",
		"@blocknote/xl-docx-exporter": "^0.56.0",
		"@blocknote/xl-odt-exporter": "^0.56.0",
		"@blocknote/xl-pdf-exporter": "^0.56.0",
		"@cloudillo/core": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@cloudillo/rtdb": "workspace:^",
		"@jest/globals": "^30.5.2",
		"@mantine/core": "^9.7.3",
		"@mantine/hooks": "^9.7.3",
		"@react-pdf/renderer": "^4.9.0",
		"@symbion/opalui": "^0.16.0",
		"@symbion/runtype": "^1.3.1",
		"@tiptap/core": "^3.32.0",
		"@tiptap/pm": "^3.32.0",
		"@types/jest": "^30.0.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"docx": "^9.12.0",
		"esbuild": "^0.28.2",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-icons": "^5.7.0",
		"react-router-dom": "^7.18.4",
		"rimraf": "^6.1.3",
		"ts-jest": "^29.4.15",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2"
	},
	"dependencies": {
		"buffer": "^6.0.3",
		"fflate": "^0.8.3",
		"i18next": "^26.5.2",
		"react-i18next": "^17.1.0"
	}
}
